import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useMe } from '../hooks/useAuth';
import { ErrorState, Skeleton } from './ui/Feedback';

/** Renders children only for signed-in users; everyone else is sent to sign in and brought back afterwards. */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { data: user, isLoading, error, refetch } = useMe();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex min-h-full items-center justify-center p-8" role="status" aria-label="Loading your account">
        <Skeleton className="h-10 w-48" />
      </div>
    );
  }
  if (error) return <ErrorState title="Could not reach PR Pilot" error={error} onRetry={() => void refetch()} />;
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/signin?next=${next}`} replace />;
  }
  return <>{children}</>;
}

/** Only allow internal redirect targets (prevents open redirects via ?next=). */
export function safeNext(raw: string | null): string {
  if (!raw || !raw.startsWith('/app') || raw.startsWith('//')) return '/app';
  return raw;
}
